export const ProjectData = [
  {
    id: 0,
    title: 'Chronoline',
    about:
      'Chronoline is a game where the player needs to place a card in the correct chronological position in a timeline of historic events',
    tags: ['React', 'TypeScript', 'Jest', 'HTML', 'CSS'],
    demo: 'https://chronoline.app/',
    image: require('../../assets/chronoline.png'),
  },
  {
    id: 1,
    title: 'TV Shows Project',
    about:
      'The TV Shows webpage fetches data from the TV Maze API and shows it in a compelling way using React and Typescript. It allows the user to choose from different TV shows and filter for specific episodes',
    tags: ['React', 'TypeScript', 'Jest', 'HTML', 'CSS'],
    demo: 'https://tv-shows-project-alli-maria.netlify.app/',
    github: 'https://github.com/mariatens/tv-shows-project',
    image: require('../../assets/tvshows.jpeg'),
  },
  /* {
    id: 2,
    title: 'Paste Bin',
    about:
      'Paste bin with functionality to comment on pastes and delete pastes/comments',
    tags: ['React', 'Typescript', 'Jest', 'Node', 'Express', 'PostgreSQL'],
    demo: 'https://github.com/ThantZinPhyo-OP/Portfolio-Website',
    github: 'https://github.com/DidierOsindero/paste-bin-frontend',
    image: require('../../assets/pastebin.png'),
  },
  {
    id: 3,
    title: 'To do app',
    about:
      'App with functionality to add, delete, edit and mark To Dos as complete',
    tags: ['React', 'Typescript', 'Jest', 'Node', 'Express', 'PostgreSQL'],
    demo: 'https://mariatens-todo.netlify.app/',
    github: 'https://github.com/mariatens/todo-front-end',
    image: require('../../assets/todoapp.png'),
  }, */
];
